import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled from 'styled-components';
import { memo } from 'react';
import LightweightSection from '@dbh/section';
import Spinner from '@dbh/spinner';
import { getNavbarHeightFromProps } from '@dbh/navbar';
import throwInServerSideRendering from '@dbh/throw-in-server-side-rendering';

var _StyledLightweightSec;const LoadingView=/*#__PURE__*/memo(()=>(throwInServerSideRendering("LoadingView"),_StyledLightweightSec||(_StyledLightweightSec=/*#__PURE__*/_jsx(_StyledLightweightSection,{},void 0,/*#__PURE__*/_jsx(Spinner,{size:"ff0",visible:!0})))));LoadingView.displayName="LoadingView";var _StyledLightweightSection=/*#__PURE__*/_styled(LightweightSection).withConfig({componentId:"sc-6adm50-0"})(["display:flex;flex-direction:column;justify-content:center;align-items:center;overflow:hidden;height:calc(100vh - ",");border-bottom:none;margin-bottom:unset;"],getNavbarHeightFromProps);

export { LoadingView as default };
